const FILTER_TYPES = {
  THINGS: "things",
  ALL_THINGS: "allThings"
};

export default FILTER_TYPES;
